import React from "react";

import { STATES_INVERTED } from "Constants";
import isIntuit from "Intuit/isIntuit";
import { identity } from "lodash";
import { validateRequired, validateEmail, validateDate, validateName, validateHiredAt, composeValidators } from "Utils/Validations";

import AppearingElement from "Common/AppearingElement";
import { SIFinalFormField, SIFormRadioGroup, SIFormSelect } from "Common/forms";
import { dateMask } from "Common/forms/masks";
import { Row } from "Common/Grid";

type Props = {
  employeeWillFillApplication: boolean;
  employeeFullName: string;
  canLinkAccount: boolean;
};

const AddEmployeeForm = ({ employeeFullName, employeeWillFillApplication, canLinkAccount }: Props) => (
  <div>
    <Row>
      <SIFinalFormField
        name="employee[full_name]"
        label="Full Name"
        type="text"
        placeholder="Full Name"
        validate={composeValidators(validateRequired, validateName)}
        sm={6}
      />
    </Row>
    <Row>
      <SIFinalFormField
        name="employee[hired_at]"
        label={isIntuit() ? "Hire Date" : "Employee Hire Date"}
        hint="MM/DD/YYYY"
        type="text"
        componentProps={{ mask: dateMask }}
        validate={composeValidators(validateRequired, validateDate, validateHiredAt)}
        sm={6}
      />
    </Row>
    <Row>
      <SIFinalFormField
        name="employee[state]"
        label="State of Residence"
        component={SIFormSelect}
        componentProps={{ options: STATES_INVERTED }}
        validate={validateRequired}
        sm={6}
      />
    </Row>
    <Row>
      <SIFinalFormField
        name="employee[employee_type]"
        label={isIntuit() ? "Owner or Contractor" : "Employee Type"}
        component={SIFormRadioGroup}
        componentProps={{
          options: [!isIntuit() && (["full_time", "Payroll Employee (W-2)"] as any), ["owner", "Owner, not on Payroll"], ["1099", "1099 Contractor"]].filter(
            identity,
          ),
        }}
        validate={validateRequired}
      />
    </Row>
    <Row>
      <SIFinalFormField
        name="employee[employee_fill]"
        label={`Who will complete ${employeeFullName}'s application?`}
        component={SIFormRadioGroup}
        componentProps={
          canLinkAccount
            ? {
                options: [
                  ["Yes", `Please email ${employeeFullName} an application.`],
                  ["No", `I will fill out the application for ${employeeFullName}.`],

                  ["LinkAccount", `I am ${employeeFullName}`],
                ],
              }
            : {
                options: [
                  ["Yes", `Please email ${employeeFullName} an application.`],
                  ["No", `I will fill out the application for ${employeeFullName}.`],
                ],
              }
        }
        validate={validateRequired}
      />
    </Row>
    <AppearingElement show={employeeWillFillApplication === "Yes"}>
      <Row>
        <SIFinalFormField name="employee[email]" label="Email Address" type="email" validate={composeValidators(validateEmail, validateRequired)} />
      </Row>
    </AppearingElement>
  </div>
);

export default AddEmployeeForm;
